import * as React from 'react';

interface OptionsListEditorAddButtonProps {
  text: string;
  onClickAdd(e);
}

export const OptionsListEditorAddButton = (props: OptionsListEditorAddButtonProps) => {
  const { onClickAdd, text } = props;
  return (
    <a href='#' className='option-picker-link mt-3' onClick={onClickAdd}>
      <span className='option-picker-link-plus'>+</span>
      <span className='option-picker-link-add'>{text}</span>
    </a>
  );
};
